import { hasConsentFor } from '../hooks/useConsent';

type MarketingAttributionModule = typeof import('./marketingAttribution');

let attributionModulePromise: Promise<MarketingAttributionModule> | null = null;

export const loadMarketingAttribution = (): Promise<MarketingAttributionModule> => {
  if (!attributionModulePromise) {
    attributionModulePromise = import(
      /* webpackChunkName: "marketingAttribution" */ './marketingAttribution'
    ).catch((error) => {
      attributionModulePromise = null;
      throw error;
    });
  }

  return attributionModulePromise;
};

export const trackConversionAfterConsent = (
  event: string,
  value?: number,
  metadata?: Record<string, unknown>,
) => {
  if (!hasConsentFor('analytics')) return;

  void loadMarketingAttribution()
    .then(({ trackConversion }) => trackConversion(event, value, metadata))
    .catch(() => undefined);
};

export const trackConversionOnceAfterConsent = (
  event: string,
  dedupeKey: string,
  metadata?: Record<string, unknown>,
  authToken?: string,
) => {
  if (!hasConsentFor('analytics')) return;

  void loadMarketingAttribution()
    .then(({ trackConversionOnce }) => trackConversionOnce(
      event,
      dedupeKey,
      undefined,
      metadata,
      authToken ? { authToken } : undefined,
    ))
    .catch(() => undefined);
};
